import React, { useEffect, useRef, useState } from "react";
import { styled } from "@mui/system";
import { Chart, ChartProps, Legend, PieSeries } from "@devexpress/dx-react-chart-material-ui";
import { EventTracker, HoverState, SelectionState } from "@devexpress/dx-react-chart";
import { ListItem, Tooltip, Typography } from "@mui/material";
import { shortenString } from "../../helpers/dataFormat";
import useResponsive from "helpers/useResponsive";
import { Target } from "lucide-react";
const palette = ["#42A5F5", "#FF7043", "#9CCC65", "#FFCA28", "#26A69A", "#EC407A"];

const LegendRoot = (props: any) => (
  <Legend.Root
    {...props}
    sx={{
      width: { xs: "300px", md: "50%" },
      display: "flex",
      flexDirection: "column",

      margin: "auto",
      // backgroundColor: "green",
    }}
  />
);

const LegendLabel = (props: any & { text: string }) => {
  return (


    <Legend.Label
      {...props}
      title={props.text}
      // text={shortenString(props.text, 15)}
      sx={{
        // color: "red",
        width: "95%",
        display: "flex",
        alignItems: "right",
        paddingLeft: "0 !important",
        // backgroundColor: "red",
        fontSize: {
          sm: "5px",
          md: "18px",
        },
        "&>span": {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",

        }
      }}
    >

    </Legend.Label>


  );
}
const MarkerComponent = (props: any) => {
  return <Legend.Marker  {...props} />;
};
export const Container = styled("div")(({ theme }) => ({
  position: "relative",

  [theme.breakpoints.down("sm")]: {
    display: "block", // تغییر به حالت بلاک در صفحات موبایل
  },
}));
export const ChartTitle = styled("div")(({ theme, width }: { theme?: ThemeObjType; width: number }) => {
  return {
    position: "absolute",
    height: "60px",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "column",
    // top: 0,
    right: width / 2,
    // left: 0,
    width: "80px",
    top: "50%",
    transform: "translateY(-50%) translateX(-50%)",
  };
});
export const BottomChartContainer = styled("div")(({ theme }) => ({
  position: "absolute",
  // backgroundColor: "green",
  width: "100%",
  hright: "100%",
  top: 0,
  left: 0,
}));

const chartData = [
  { source: "منبع 1", amount: 25 },
  { source: "منبع 2", amount: 20 },
  { source: "منبع 3", amount: 15 },
  { source: "منبع 4", amount: 11 },
  { source: "منبع 5", amount: 8 },
];

const PieComponent = (props: PieSeries.PointProps & { selection: any[] }) => {
  const { selection } = props;
  const selected = selection[0] == props.index;

  return (
    <PieSeries.Point
      style={{
        fill: selected ? props.color : "#C9D2DE",
        stroke: selected ? props.color : "#e3e7f0",
        transition: "all 1s ease",
        strokeWidth: "5px",
        position: "relative",

        // zIndex: "9999",
      }}
      {...props}
    />
  );
};

const countPercent = (input: PieChartDataType, key: number) => {
  try {
    let sum = 0;
    input.forEach((element) => {
      sum += element.percent;
    });

    return `${Math.floor((input[key].percent * 100) / sum)} %`;
  } catch {
    return "0 %";
  }
};

const PieChart = ({ height, data = [] }: { height?: number; data: PieChartDataType }) => {
  const ChartWithChildren = Chart as React.ComponentType<ChartProps & { children: React.ReactNode }>;
  const [selection, setSelection] = useState<string>("");
  const chartData = data.filter((item) => item.percent !== 0);
  const ContainerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);
  const { isDesktop } = useResponsive();
  //ojaghi added
  const [open, setOpen] = useState(false)
  const handleTooltipClose = () => {
    setOpen(false);
  };
  const handleTooltipOpen = (index: number | undefined) => {
    if (typeof index === 'number') {
      setOpen(true);
      setSelection(`${data[index].title} (%${data[index].percent})`)
    } else {
      setOpen(false)
    }
  };
  //ojaghi added
  useEffect(() => {
    setWidth(ContainerRef?.current?.getBoundingClientRect()?.width || (0 as number));
  }, [ContainerRef]);

  //const MyPieComponent = (props: PieSeries.PointProps) => <PieComponent {...props} selection={selection} />;
  return (
    <Container ref={ContainerRef}>
      <ChartWithChildren height={height || 350} data={chartData}>
        <PieSeries
          valueField="percent"
          argumentField="title"
          innerRadius={0.5}
          outerRadius={0.7}
        //pointComponent={MyPieComponent}
        />
        <EventTracker
          onClick={({ targets }) => {
            //  const target = targets[0];
            //setSelection([target.point]);
          }}
        />
        <HoverState onHoverChange={(target) => { handleTooltipOpen(target?.point) }} />
        {/* <SelectionState selection={selection} /> */}

        <Legend

          position={window.innerWidth > 768 ? "left" : "bottom"}
          markerComponent={MarkerComponent}
          rootComponent={LegendRoot}
          labelComponent={LegendLabel}
        />
      </ChartWithChildren>
      <Tooltip
        PopperProps={{
          disablePortal: true,
        }}
        onClose={handleTooltipClose}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={selection}
      >
        <div className="absolute inset-x-0 h-16 top-0"></div>
      </Tooltip>
      {/* <ChartTitle sx={{
        top: { xs: "16%", md: "50%" },
        height: { xs: "45px", md: "60px" },
        transform: { xs: "translateY(-50%) translateX(50%)", md: "translateY(-50%) translateX(-60%)" }

      }} width={width}>
        <Typography sx={{ fontSize: { xs: "1rem", md: "1.5rem" } }} variant="h5" fontWeight="bold" align="center">
          {countPercent(data, selection[0])}
        </Typography>
        <Typography variant="body2" align="center" noWrap>
          {data[selection[0]]?.title ?? ""}
        </Typography>
      </ChartTitle> */}
    </Container>
  );
};

export default PieChart;
